import { updateMinorUnitApi, getMinorUnitApi } from "@/api/action-defines/site-management";
import { showToast } from '@/@core/utils/utils';
import { mapGetters, mapState } from 'vuex';
import { EInvoiceConfigurationCode } from "@/@core/data/enum/menuCode";

export default {
  data() {
    return {
      minorUnitQuantity: '',
      minorUnitUnitPriceQuantity: '',
    }
  },
  async created() {
    await this.getEInvoiceConfiguration();
  },
  computed: {
     ...mapGetters({
          $ls_CurrentSiteID: 'auth/currentSiteID',
          $lsAllowOperation: 'app/allowOperation',
        }),
   
  },
  methods: {
    preventInvalidChar(event) {
      const char = String.fromCharCode(event.keyCode || event.which);
      const isValid = /^[0-9]$/.test(char);
      if (!isValid) {
        event.preventDefault();
      }
    },
   isCanEditEInvoiceConfiguration() {    
        return this.$lsAllowOperation(EInvoiceConfigurationCode.EDIT);
    },
    async getEInvoiceConfiguration() {
      try {
        const response = await getMinorUnitApi();
        if (response && response.Data) {
          this.minorUnitQuantity = response.Data.MinorUnit;
          this.minorUnitUnitPriceQuantity = response.Data.PriceMinorUnit;
        }
      } catch (error) {
        showToast('error', 'Lấy thông tin số thập phân thất bại');
      }
    },

    async updateEInvoiceConfiguration() {
      try {
        const BodyData = {
          MinorUnit: this.minorUnitQuantity,
          PriceMinorUnit: this.minorUnitUnitPriceQuantity
        };
        const response = await updateMinorUnitApi({ BodyData });

        if (response && response.StatusCode == 200) {
          showToast('success', 'Cập nhật thành công');
        } else {
          showToast('error', 'Cập nhật thất bại');
        }
      } catch (error) {
        showToast('error', 'Cập nhật số thập phân lỗi');
      }
    }

  },
}
